import React from "react";
import RoomForm from "./roomFormWrapper/RoomForm";

export default function RommFormWrapper({ADD_ROOM, UPDATE_ROOM, user, profile}){
    let props = {
        ADD_ROOM, 
        UPDATE_ROOM,
        user: user ? user.profile_info : profile
    };
    
    return (
        <RoomForm props={props}/>
    );
}


// WEBPACK FOOTER //
// ./src/components/general/RommFormWrapper.jsx